import { useSelector } from 'react-redux';
import { selectActiveServiceId, selectServiceIds } from '../../../../../../../selectors/publishTerms';
import {
  IDiffPricingIds,
  selectAnalyticsDiffPricingIds,
  selectAnalyticsFormId,
  selectAnalyticsOfferStatus,
  selectAnalyticsProduct,
} from '../../../../../../../selectors/analytics';
import { selectCurrentBet } from '../../../../../../../selectors/auction';
import { selectBetPosition } from '../../../../../../../selectors/betPosition';
import { EServiceId } from '../../../../../../../types/reducers/publishTerms';
import { IAnalyticsProduct, TAnalyticsOfferStatus } from '../../../../../../../types/analytics';
import { IBetPosition } from '../../../../../../../types/reducers/betPosition';

interface IUseServicesAnalytics {
  activeServiceId: EServiceId;
  analyticsFormId: string;
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsProduct: IAnalyticsProduct;
  bet: number;
  betPosition: IBetPosition | null;
  diffPricingIds: IDiffPricingIds | null;
  serviceIds: EServiceId[];
}

export const useServicesAnalyticsParams = (): IUseServicesAnalytics => {
  const activeServiceId = useSelector(selectActiveServiceId)!;
  const serviceIds = useSelector(selectServiceIds);
  const analyticsOfferStatus = useSelector(selectAnalyticsOfferStatus);
  const bet = useSelector(selectCurrentBet);
  const analyticsProduct = useSelector(selectAnalyticsProduct);
  const betPosition = useSelector(selectBetPosition);
  const analyticsFormId = useSelector(selectAnalyticsFormId);
  const diffPricingIds = useSelector(selectAnalyticsDiffPricingIds);

  return {
    activeServiceId,
    serviceIds,
    analyticsOfferStatus,
    bet,
    analyticsProduct,
    betPosition,
    analyticsFormId,
    diffPricingIds,
  };
};
